import { render, staticRenderFns } from "./UtmBannerRegister.vue?vue&type=template&id=70547485&"
import script from "./UtmBannerRegister.vue?vue&type=script&lang=js&"
export * from "./UtmBannerRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports